const CountryTooltipHandler = (stateCountryTooltip, setCountryTooltip) => {
  return {
    updatePosition: (position) => {
      setCountryTooltip("position", position);
      setCountryTooltip("visible", true);
    },

    hide: () => {
      setCountryTooltip("visible", false);
    },

    show: () => {
      setCountryTooltip("visible", true);
    },
  };
};

export default CountryTooltipHandler;
